import { config } from 'config';
import { actions } from './actions.js';
import { mutations } from './mutations.js';
import { getters } from './getters.js';
import * as MUTATIONS from '@/store/constants/mutations.js';
import * as GETTERS from '@/store/constants/getters.js';
import * as ACTIONS from '@/store/constants/actions.js';

export const version = () => ({
    state: {
        is_out_of_date: false,
        console_version: _CONSOLE_VERSION_, // eslint-disable-line no-undef
    },
    actions,
    mutations,
    getters,
});

/**
 *
 * run once on store initialization to periodically check if the console version has changed
 *
 * @param {Object} store vuex store
 */
export const versionPlugin = ({ commit, getters, dispatch }) => {
    setInterval(() => {
        if (!getters[GETTERS.IS_OUT_OF_DATE]) {
            dispatch(ACTIONS.GET_CONSOLE_VERSION).then((version) => {
                if (version !== getters[GETTERS.CONSOLE_VERSION]) {
                    // If the version is different, then we are out of date
                    commit(MUTATIONS.SET_IS_OUT_OF_DATE, true);
                }
            });
        }
    }, config.version_poll_interval || 1000);
};
